export default __webpack_public_path__ + "static/media/mobile-8.4b122efa.png";